import PropTypes from "prop-types";
import React, { useContext } from "react";

import { PlacementFactory } from "@swa-ui/placements";

import { SystemMessagesContext } from "../SystemMessagesProvider";

/**
 * The DotcomSystemMessages component renders system messages
 */
export const DotcomSystemMessages = (props) => {
  const { className } = props;
  const { systemMessagePlacementIds } = useContext(SystemMessagesContext);

  return <div className={className}>{renderSystemMessages()}</div>;

  function renderSystemMessages() {
    return systemMessagePlacementIds.map((systemMessagePlacementId) => (
      <PlacementFactory id={systemMessagePlacementId} key={systemMessagePlacementId} />
    ));
  }
};

DotcomSystemMessages.displayName = "DotcomSystemMessages";
DotcomSystemMessages.propTypes = {
  /** Additional classes for positioning the component. */
  className: PropTypes.string,
};
